import { render, staticRenderFns } from "./ed-content-section-loading.vue?vue&type=template&id=c31b7928&scoped=true&"
import script from "./ed-content-section-loading.ts?vue&type=script&lang=ts&"
export * from "./ed-content-section-loading.ts?vue&type=script&lang=ts&"
import style0 from "./ed-content-section-loading.scss?vue&type=style&index=0&id=c31b7928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31b7928",
  null
  
)

export default component.exports